import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api, errMessage } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { toast } from "@/components/ui/sonner";

const COUNTRIES = ["AT", "DE", "CH", "FR", "IT", "ES", "NL", "BE", "LU", "GB", "US"];

export function BillingForm({ onSaved }) {
  const { user, setUser } = useAuth();
  const prof = user?.profile || {};
  const [form, setForm] = useState({
    name: user?.name || "",
    phone: user?.phone || "",
    country: user?.country || "AT",
    billing_address: prof.billing_address || "",
    vat_number: prof.vat_number || "",
  });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/profile/billing", form);
      setUser(data);
      toast.success("Rechnungsdaten gespeichert.");
      onSaved?.(data);
    } catch (err) {
      toast.error(errMessage(err, "Speichern fehlgeschlagen."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4" data-testid="billing-form">
      <div className="space-y-1.5">
        <Label htmlFor="b-name">Voller Name</Label>
        <Input id="b-name" required value={form.name} onChange={set("name")} data-testid="billing-name" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label htmlFor="b-phone">Telefon</Label>
          <Input id="b-phone" required value={form.phone} onChange={set("phone")} placeholder="+43 …" data-testid="billing-phone" />
        </div>
        <div className="space-y-1.5">
          <Label>Land</Label>
          <Select value={form.country} onValueChange={(v) => setForm((f) => ({ ...f, country: v }))}>
            <SelectTrigger data-testid="billing-country"><SelectValue /></SelectTrigger>
            <SelectContent>
              {COUNTRIES.map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="b-addr">Rechnungsadresse</Label>
        <Textarea id="b-addr" required rows={3} value={form.billing_address} onChange={set("billing_address")}
          placeholder="Straße, PLZ, Ort" data-testid="billing-address" />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="b-vat">USt-IdNr. (optional)</Label>
        <Input id="b-vat" value={form.vat_number} onChange={set("vat_number")} placeholder="ATU…" data-testid="billing-vat" />
      </div>
      <Button type="submit" className="rounded-full" disabled={loading} data-testid="billing-submit">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Speichern"}
      </Button>
    </form>
  );
}
